<script setup>
import {useI18n} from "vue-i18n";
import {DE, EN} from "@/i18n/locales";

const {locale, availableLocales} = useI18n({useScope: 'global'})
</script>

<template>
  <div class="locale-switcher" role="group" :aria-label="$t('language')">
    <button
        v-for="lc in availableLocales"
        :key="'locale-' + lc"
        type="button"
        class="locale-switcher__tab"
        :class="{'locale-switcher__tab--active': locale === lc}"
        :aria-pressed="locale === lc"
        :title="$t('locales.' + lc)"
        @click="locale = lc"
    >
      <svg v-if="lc === DE" viewBox="0 0 20 14" width="19" height="13.3" class="locale-switcher__flag" aria-hidden="true">
        <rect width="20" height="14" fill="#111111"/>
        <rect y="4.667" width="20" height="4.666" fill="#DD0000"/>
        <rect y="9.333" width="20" height="4.667" fill="#FFCE00"/>
      </svg>
      <svg v-else-if="lc === EN" viewBox="0 0 20 14" width="19" height="13.3" class="locale-switcher__flag" aria-hidden="true">
        <rect width="20" height="14" fill="#012169"/>
        <path d="M0 0 L20 14 M20 0 L0 14" stroke="#FFFFFF" stroke-width="2.8"/>
        <path d="M0 0 L20 14 M20 0 L0 14" stroke="#C8102E" stroke-width="1.3"/>
        <rect y="5" width="20" height="4" fill="#FFFFFF"/>
        <rect x="8" width="4" height="14" fill="#FFFFFF"/>
        <rect y="5.9" width="20" height="2.2" fill="#C8102E"/>
        <rect x="8.9" width="2.2" height="14" fill="#C8102E"/>
      </svg>
      {{ lc.toUpperCase() }}
    </button>
  </div>
</template>

<style scoped>
.locale-switcher {
  display: flex;
  align-items: center;
  gap: 2px;
  padding: 3px;
  background: var(--ww-surface-sub-alt);
  border-radius: var(--ww-r-sm);
}

.locale-switcher__tab {
  display: flex;
  align-items: center;
  gap: 6px;
  border: 0;
  border-radius: 9px;
  padding: 7px 11px;
  font-size: 13px;
  font-weight: 700;
  background: transparent;
  color: var(--ww-text-label);
  transition: background-color 0.2s ease, color 0.2s ease;
}

.locale-switcher__tab--active {
  background: var(--ww-surface);
  color: var(--ww-text);
  box-shadow: var(--ww-shadow-pill);
}

.locale-switcher__flag {
  border-radius: 2.5px;
}
</style>
